import {Component, Input, OnInit} from '@angular/core';
import {SpecialRequest} from '../special-request.model';
import {SpecialRequestService} from '../special-request.service';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-special-request-item',
  templateUrl: './special-request-item.component.html',
  styleUrls: ['./special-request-item.component.css']
})
export class SpecialRequestItemComponent implements OnInit {
  @Input()
  specialRequest: SpecialRequest;

  constructor(private service: SpecialRequestService) {
  }

  ngOnInit(): void {
  }

  declined(): boolean {
    return this.specialRequest?.declineReason?.length > 0;
  }

  downloadSupportingMaterial(): void {
    this.service.downloadSupportingMaterial(this.specialRequest.id).subscribe((file) => {
      saveAs(file, this.specialRequest.supportingMaterialFileName);
    });
  }
}
